import { default as session } from './sessionConstants';
import { default as ui } from './uiConstants';

export default {
  session,
  ui,
};
